import api from '../api'
import router from '@/router'

const state = {

	loading: false,
	buttonLoading: false,
	sessionList: {},
	session: {},
	sessionAverage: {},
	sessionUserList: {},
	sessionUserDisplay: {},
	sessionUserCharts: {},
	sessionTypeList: [],
	selectedUsers: [],
	subjectList: [],
	emailQRError: ''
}

const mutations = {
	SET_SESSION_LIST (state, payload) {
		state.sessionList = payload
	},

	SET_LOADING (state, payload) {
		state.loading = payload
	},

	SET_BUTTON_LOADING (state, payload) {
		state.buttonLoading = payload
	},

	SET_SESSION (state, payload) {
		state.session = payload
	},

	SET_SESSION_AVERAGE (state, payload) {
		state.sessionAverage = payload
	},

	SET_SESSION_USER_LIST (state, payload) {
		state.sessionUserList = payload
	},

	SET_SESSION_USER_DISPLAY (state, payload) {
		state.sessionUserDisplay = payload
	},

	SET_SESSION_USER_CHARTS (state, payload) {
		state.sessionUserCharts = payload
	},

	SET_SESSION_TYPE_LIST (state, payload) {
		state.sessionTypeList = payload
	},

	SET_SELECTED_USERS (state, payload) {
		state.selectedUsers = payload
	},

	SET_PARTICIPANTS (state, payload) {
		this._vm.$set(state.session, 'no_of_participants', payload)
	},

	SET_SESSION_STATUS (state, payload) {
		this._vm.$set(state.session, 'status', payload)
	},

	SET_SUBJECT_LIST (state, payload) {
		state.subjectList = payload
	},

	SET_EMAIL_QR_ERROR (state, payload) {
		this._vm.$set(state, 'emailQRError', payload)
	}
}

const actions = {
	// async createSession ({ commit }, payload) {
	// 	commit('SET_LOADING', true)
	// 	const { data, status } = await api('post', '/remote/insight/session/create-session', payload)
	// 	commit('SET_LOADING', false)

	// 	if (status) {
	// 		commit('banner/TOGGLE_BANNER', {
	// 			status: true,
	// 			message: 'success_session_create',
	// 			type: 'success'
	// 		}, { root: true })

	// 		return data.data
	// 	}

	// 	if (data.message) {
	// 		commit('banner/TOGGLE_BANNER', {
	// 			status: true,
	// 			message: data.message,
	// 			type: 'failed'
	// 		}, { root: true })
	// 	} else {
	// 		commit('banner/TOGGLE_BANNER', {
	// 			status: true,
	// 			message: 'failed_session_create',
	// 			type: 'failed'
	// 		}, { root: true })
	// 	}
	// 	return null
	// },

	async updateSession ({ commit, state }, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session/edit-session', payload)

		if (status) {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_session_update',
				type: 'success'
			}, { root: true })

			if (state.session.id) {
				commit('SET_BUTTON_LOADING', true)
				const newSession = await api('get', '/remote/insight/session/view', { client_id: data.data.client_id, id: data.data.id, language: 'english' })
				if (newSession.status) {
					commit('SET_SESSION', newSession.data.data)
				}
				commit('SET_BUTTON_LOADING', false)
			}

			commit('SET_BUTTON_LOADING', false)
			return true
		}

		if (data.message) {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: data.message,
				type: 'failed'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_update',
				type: 'failed'
			}, { root: true })
		}

		commit('SET_BUTTON_LOADING', false)
		return false
	},

	async getSessionList ({commit}, payload) {
		// commit('SET_LOADING', true)
		const { data, status } = await api('get', '/cms/session/list', payload)
		if (status) {
			commit('SET_SESSION_LIST', data.data)
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				type: 'failed'
			}, { root: true })

			// console.log(error)
		}

		// commit('SET_LOADING', false)
	},

    async actionSession ({ commit }, payload) {
        commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/cms/session/action', payload)

		if (status) {
			commit('SET_SESSION_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_session_update',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_resume',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
    },

	async resumeSession ({commit}, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session/resume', payload)

		if (status) {
			commit('SET_SESSION_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_session_resume',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_resume',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async pauseSession ({commit}, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session/pause', payload)

		if (status) {
			commit('SET_SESSION_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_session_pause',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_pause',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}

		commit('SET_BUTTON_LOADING', false)
	},

	async stopSession ({commit}, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session/stop', payload)

		if (status) {
			commit('SET_SESSION_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_session_stop',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_stop',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async archiveSession ({commit}, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session/archive', payload)

		if (status) {
			commit('SET_SESSION_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_session_delete',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_delete',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async endSession ({commit}, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { status } = await api('post', '/remote/insight/session/stop', payload)

		if (status) {
			commit('SET_BUTTON_LOADING', false)
			return true
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_session_stop',
				type: 'failed'
			}, { root: true })

			commit('SET_BUTTON_LOADING', false)
			return false
		}
	},

	async getSession ({ commit }, payload) {
		// commit('SET_LOADING', true)
		const { data, status } = await api('get', '/cms/session/view', payload)

		if (status) {
			commit('SET_SESSION', data.data)
		} else {
			commit('SET_SESSION', {})
		}

		// commit('SET_LOADING', false)
	},

	async getSessionAverage ({ commit }, payload) {
		// commit('SET_LOADING', true)
		const { data, status } = await api('get', '/remote/insight/session-user/average', payload)

		if (status) {
			commit('SET_SESSION_AVERAGE', data)
			commit('SET_SESSION_STATUS', data.data.session_status)
		}
		// commit('SET_LOADING', false)
	},

	async getSessionUserList ({ commit }, payload) {
		const { data, status } = await api('get', '/remote/insight/session-user/list', payload)
		if (status) commit('SET_SESSION_USER_LIST', data.data)
	},

	async getSessionUserDisplay ({ commit }, payload) {
		const { data, status } = await api('get', '/remote/insight/session-user/list', payload)
		if (status) commit('SET_SESSION_USER_DISPLAY', data.data)
	},

	async resumeSessionUser ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session-user/resume', payload)
		if (status) {
			commit('SET_SESSION_USER_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_user_resume',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_user_resume',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async pauseSessionUser ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session-user/pause', payload)

		if (status) {
			commit('SET_SESSION_USER_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_user_pause',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_user_pause',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}

		commit('SET_BUTTON_LOADING', false)
	},

	async stopSessionUser ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session-user/stop', payload)

		if (status) {
			commit('SET_SESSION_USER_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_user_stop',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_user_stop',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async deleteSessionUser ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session-user/delete', payload)

		if (status) {
			commit('SET_SESSION_USER_LIST', data.data)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_user_delete',
				type: 'success'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_user_delete',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async getSessionUserShareLink ({ commit }, payload) {
		// commit('SET_LOADING', true)
		const { data, status } = await api('get', '/remote/insight/session-user/share-link', payload)

		if (status) {
			commit('SET_SESSION_USER_DISPLAY', data.data.list)
			return
		}

		router.push({ name: 'PageNotFound' })
		// commit('SET_LOADING', false)
	},

	async getSessionUserCharts ({ commit }, payload) {
		commit('SET_LOADING', true)
		const { data, status } = await api('get', '/remote/insight/session-user/list', payload)

		if (status) {
			commit('SET_SESSION_USER_CHARTS', data.data)
		}
		commit('SET_LOADING', false)
	},

	async getSessionTypeList ({ commit }) {
		const { data, status } = await api('get', '/remote/insight/session/session-type', {language: 'english'})
		if (status) {
			commit('SET_SESSION_TYPE_LIST', data.data)
		}
	},

	setSelectedUsers ({ commit }, payload) {
		commit('SET_SELECTED_USERS', payload)
	},

	async getSubjectList ({ commit }) {
		const { data, status } = await api('get', '/remote/insight/session/subject-list', {language: 'english'})
		if (status) {
			commit('SET_SUBJECT_LIST', data.data)
		}
	},

	async downloadExcel ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)

		const { data, status } = await api('post', '/remote/insight/session-user/generate-report', payload, true)

		if (status && data.type !== 'text/html' && data.type !== 'application/json') {
			commit('SET_BUTTON_LOADING', false)
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_download',
				type: 'success'
			}, { root: true })
			return { isSuccess: true, data }
		}

		commit('SET_BUTTON_LOADING', false)
		commit('banner/TOGGLE_BANNER', {
			status: true,
			message: 'failed_report_download',
			type: 'failed'
		}, { root: true })
		return { isSuccess: false }
	},

	async emailReport ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)

		const { data, status } = await api('post', '/remote/insight/session-user/generate-report', payload)

		if (status) {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_email_sent',
				type: 'success'
			}, { root: true })
			commit('SET_SELECTED_USERS', [])
			commit('SET_BUTTON_LOADING', false)
			return
		}

		if (data.message) {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: data.message,
				type: 'failed'
			}, { root: true })
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_report_email',
				type: 'failed'
			}, { root: true })
		}
		commit('SET_SELECTED_USERS', [])
		commit('SET_BUTTON_LOADING', false)
	},

	async downloadQRCode ({ commit }, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { data, status } = await api('post', '/remote/insight/session/download-qrcode', payload.form, true)
		if (status) {
			const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([data]))
            link.setAttribute('download', `${payload.session.session_name} - Upmood Session QR Code.pdf`)
			document.body.appendChild(link)
			console.log(link)
            link.click()
			link.parentNode.removeChild(link)
		} else {
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'failed_qr_download',
				type: 'failed'
			}, { root: true })
			// console.log(error)
		}
		commit('SET_BUTTON_LOADING', false)
	},

	async emailQRCode ({commit}, payload) {
		commit('SET_BUTTON_LOADING', true)
		const { error, status } = await api('post', '/remote/insight/session/send-qrcode', payload)

		if (status) {
			commit('SET_BUTTON_LOADING', false)
			commit('SET_EMAIL_QR_ERROR', '')
			commit('banner/TOGGLE_BANNER', {
				status: true,
				message: 'success_email_sent',
				type: 'success'
			}, { root: true })
			return true
		}

		commit('SET_BUTTON_LOADING', false)
		commit('SET_EMAIL_QR_ERROR', error.email[0])
		return false
	}
}

export default {
	state,
	mutations,
	actions,
	namespaced: true
}
